import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import { Redirect } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from "../../../hooks/useForm";
import {
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  cleanAfiliadoSeleccionado,
  cleanSolicitudes,
  clearReducer,
  generateExcelConsultaAuditoria,
  getBandejasPorUsuario,
  getSolicitudesContadoresGestion,
  getTiposSolicitudes,
  setEstadoSolicitudes,
} from "../../../actions/autorizaciones/Autorizaciones";
import { AutorizacionesBuscador } from "../Ingreso/AutorizacionesBuscador";
import { SolicitudItem } from "./SolicitudItem";
import {
  AUTORIZACIONES_SOLICITUDES_ESTADOS,
  AREAS_USUARIOS,
  AUTORIZACIONES_BANDEJAS,
  TIPOS_AUTORIZACIONES,
} from "../../../utils/constants";
import { Search } from "@material-ui/icons";
import { TableHeadGestionAuditoria } from "./TableHeadGestionAuditoria";
import { startAlerta } from "../../../actions/ui/alertas";
//import { AutoCompleteEfectorFacturacion } from "../../liquidaciones/UI/AutoCompleteEfectorFacturacion";
import ToolbarXLSPDF from "../../compartidos/ToolbarXLSPDF";
import { traerSeccionales } from "../../../actions/cbos/seccionales";
import AutoCompletePrestadorAut from "../UI/AutoCompletePrestadorAut";

const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: -20,
    // width: "100%",
  },
  input: {
    // padding: 10,
    paddingLeft: 10,
    paddingRight: 10
  },
});

// function descendingComparator(a, b, orderBy) {
//   if (orderBy.includes('.')) {
//     const split = orderBy.split('.')
//     if (split.length === 2) {
//       if (!a[split[0]]) {
//         return -1;
//       }
//       if (!b[split[0]]) {
//         return 1;
//       }
//       if (!a[split[0]] || !b[split[0]] || b[split[0]][split[1]] < a[split[0]][split[1]]) {
//         return -1;
//       }
//       if (b[split[0]][split[1]] > a[split[0]][split[1]]) {
//         return 1;
//       }
//     }
//   }
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

// function getComparator(order, orderBy) {
//   return order === "desc"
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });
//   return stabilizedThis.map((el) => el[0]);
// }

const stateInitial = {
  idProfesional: null,
  fechaInicio: moment().subtract(15, 'days'),
  fechaFin: moment(),
};

let tieneAreaCentroMedico = false;
let tieneAreaAutorizaciones = false;
let tieneAreaAutorizacionesNacional = false;
let arrayEstadosSolicitudes = [];

export const GestionAuditoriaHome = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    afiliadoSeleccionado,
    estadoSolicitudes,
    // solicitudes: items,
    solicitudesContadores,
    solicitudesResult,
    tiposSolicitudes = [],
    bandejasDeUsuario = []
  } = useSelector((state) => state.autorizaciones);
  const { areas = [], bandejasAutorizacion = [], permisos: permisosUser } = useSelector(
    (state) => state.auth
  );
  const { efectorSeleccionado } = useSelector((state) => state.liquidaciones);
  const { items: itemsSeccionales } = useSelector((state) => state.seccionales);

  const [formValues, , , setearValor, , , , , setearVariosValores,] = useForm(stateInitial);
  // const [codigoPractica, setCodigoPractica] = useState(null);
  const [idSolicitud, setIdSolicitud] = useState(null);
  const [idTipoSolicitud, setIdTipoSolicitud] = useState(0);
  const [idBandeja, setIdBandeja] = useState(0);
  const [idSeccional, setIdSeccional] = useState(0);
  //const idTipoSolicitud = null;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [redirect, setRedirect] = useState(false);
  const { fechaInicio, fechaFin,
    cuitPrestador = "",
    nombrePrestador = "",
    idPrestador = "",
    idCartillaPrestador = "",
    idEfectorFacturacion = "",
  } = formValues;
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [radioGroupDisabled, setRadioGroupDisabled] = useState(false);

  const [orderBy /*, setOrderBy*/] = useState("");
  const [order/*, setOrder*/] = useState("asc");
  

  useEffect(() => {
    if (!props.location.state?.fromHomeScreen) {
      dispatch(clearReducer());
      dispatch(cleanSolicitudes());
      dispatch(cleanAfiliadoSeleccionado());
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(getTiposSolicitudes());
    dispatch(getBandejasPorUsuario());
    dispatch(traerSeccionales());
  }, [dispatch]);

  // const handleRequestSort = (event, property) => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };

  const verificaTieneEstado = (arrayEstados = [], estado) => {
    if (arrayEstados.find(s => s[1] === estado)) return true;

    return false
  }

  useEffect(() => {
    arrayEstadosSolicitudes = [];
  }, [dispatch, areas.idUsuarioArea]);

  const soloTieneBandejaAfi = bandejasAutorizacion.length === 1 
  && bandejasAutorizacion.filter((b) => b.idBandeja === AUTORIZACIONES_BANDEJAS.AFILIACIONES)
  ?.length > 0;

  useEffect(() => {
    const constArray = Object.entries(AUTORIZACIONES_SOLICITUDES_ESTADOS);

    tieneAreaCentroMedico =
      areas.filter((area) => area.idArea === AREAS_USUARIOS.CENTROS_MEDICOS)
        ?.length > 0;

    tieneAreaAutorizaciones =
      areas.filter((area) => area.idArea === AREAS_USUARIOS.AUTORIZACIONES_NACIONAL
        || area.idArea === AREAS_USUARIOS.AUTORIZACIONES_SECCIONAL)
        ?.length > 0;

    tieneAreaAutorizacionesNacional =
      areas.filter((area) => area.idArea === AREAS_USUARIOS.AUTORIZACIONES_NACIONAL)
        ?.length > 0;

    const mostrarBandejaPendiente =
      bandejasAutorizacion.filter(
        (bandeja) => bandeja.idBandeja !== AUTORIZACIONES_BANDEJAS.COMPRAS &&
          bandeja.idBandeja !== AUTORIZACIONES_BANDEJAS.AUDITORIA_TERRENO &&
          bandeja.idBandeja !== AUTORIZACIONES_BANDEJAS.INTERNACION_PAIS &&
          bandeja.idBandeja !== AUTORIZACIONES_BANDEJAS.PRACTICAS_INTERNACION &&           //denuncias pendientes
          bandeja.idBandeja !== AUTORIZACIONES_BANDEJAS.AUDITORIA_ADMINISTRATIVA &&
          bandeja.idBandeja !== AUTORIZACIONES_BANDEJAS.INTERNACION_DOMICILIARIA
      )?.length > 0 || props.permisoIngresoInterDom || props.permisoIngresoAutorizaciones;

    if (props.permisoIngresoAutorizaciones || props.permisoIngresoInterDom || props.permisoIngresoOxigeno) {
      if (props.permisoIngresoAutorizaciones) {
        arrayEstadosSolicitudes = constArray.filter(s =>
          s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA &&
          s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO &&
          s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS &&
          s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PRACTICAS_INTERNACION &&           //denuncias pendientes
          s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA &&
          s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_COSEGURO &&
          s[1] !== AUTORIZACIONES_SOLICITUDES_ESTADOS.OXIGENO 

        );
      }

      if (props.permisoIngresoInterDom || props.permisoIngresoOxigeno) {
        if (!verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA)) {
          arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
          ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA)];
          arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
          ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION)];
        }

        if (mostrarBandejaPendiente && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES))
          arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
          ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE)];

        arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
        ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA ||
          s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA)]
      }


    } else if (tieneAreaAutorizaciones) {
      // arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      //   ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA)];        

      // arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      //   ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION)];

      if (mostrarBandejaPendiente && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES))
        arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
        ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE)];

      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUTORIZADA)];

      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA)];

      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.CANCELADA)];
    }

    const tieneBandejaCompras =
      bandejasAutorizacion.filter(
        (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.COMPRAS
      )?.length > 0;
    const tieneBandejaVerificacionMateriales =
      bandejasAutorizacion.filter(
        (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.AUDITORIA_ADMINISTRATIVA
      )?.length > 0;
    const tieneBandejaAuditoriaTerreno =
      bandejasAutorizacion.filter(
        (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.AUDITORIA_TERRENO
      )?.length > 0;
    const tieneBandejaInternacionPais =
      bandejasAutorizacion.filter(
        (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.INTERNACION_PAIS
      )?.length > 0;
    const tieneBandejaInternacionDomiciliaria =
      bandejasAutorizacion.filter(
        (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.INTERNACION_DOMICILIARIA
      )?.length > 0;
    const tieneBandejaDenunciasPendientes =           //denuncias pendientes
      bandejasAutorizacion.filter(
        (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.PRACTICAS_INTERNACION
      )?.length > 0;
      const tieneBandejaOxigeno =
      bandejasAutorizacion.filter(
        (bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.OXIGENO
      )?.length > 0;

    if (tieneBandejaCompras && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES))
      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES)];
    if (tieneBandejaVerificacionMateriales && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA))
      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA)];
    if (tieneBandejaInternacionDomiciliaria && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA))
      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA)];
      if (tieneBandejaOxigeno && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.OXIGENO))
        arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
        ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.OXIGENO)];
    if (tieneBandejaAuditoriaTerreno && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO))
      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO)];
    if (tieneBandejaInternacionPais && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS))
      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS)];
    if ((tieneBandejaAuditoriaTerreno || tieneBandejaInternacionPais || tieneBandejaInternacionDomiciliaria || tieneBandejaOxigeno)
      && !verificaTieneEstado(arrayEstadosSolicitudes, AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA))
      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA)];
    if (tieneBandejaDenunciasPendientes)
      arrayEstadosSolicitudes = [...arrayEstadosSolicitudes,
      ...constArray.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.PRACTICAS_INTERNACION)];

    // if (arrayEstadosSolicitudes.filter(s => s[1] === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE).length > 0) {
    //   dispatch(setEstadoSolicitudes(AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE?.toString()));
    // }
  }, [areas, bandejasAutorizacion]);

  useEffect(() => {
    if (estadoSolicitudes)
      buscarConParametros(page, rowsPerPage, true);
    setPage(0)
  }, [
    dispatch,
    efectorSeleccionado?.idEfectorFacturacion,
    afiliadoSeleccionado?.id_afiliado,
    fechaInicio,
    fechaFin,
    estadoSolicitudes,
    idBandeja,
    idTipoSolicitud,
    idSeccional,
    idPrestador
  ]);

  const buscarConParametros = (page, pageSize, buscarContadores) => {
    const fechaInicioMoment = moment(fechaInicio);
    const fechaFinMoment = moment(fechaFin);
    if (fechaInicioMoment.isValid() && fechaFinMoment.isValid()) {
      const diffInDays = fechaFinMoment.diff(fechaInicioMoment, 'days');
      const limitDays = soloTieneBandejaAfi ? 90 : 60;

      if (diffInDays > limitDays) {
        dispatch(startAlerta("Las fecha desde y hasta no pueden ser mayores a " + limitDays + " días.", "error"))
      }
      else if ((efectorSeleccionado?.idEfectorFacturacion !== null && efectorSeleccionado?.idEfectorFacturacion !== undefined)
        && (idPrestador !== "" && idPrestador !== undefined)) {
        dispatch(startAlerta("No puede usar los filtros de Contrato y Prestador simultaneamente", "error"))
      }
      else {
        if (parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.AUTORIZADA
          && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA
          && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_COSEGURO
          && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA) {
          dispatch(
            getSolicitudesContadoresGestion(
              afiliadoSeleccionado?.id_afiliado,
              efectorSeleccionado?.idEfectorFacturacion,
              idBandeja,
              idSolicitud,
              idSeccional,
              idPrestador,
              idCartillaPrestador,
              idEfectorFacturacion,
              fechaInicio,
              fechaFin,
              estadoSolicitudes ? parseInt(estadoSolicitudes) : null,
              idTipoSolicitud,
              true,
              pageSize === undefined ? undefined : page, /* Evitar que entre en recursive el ep*/
              pageSize,
              buscarContadores,
              setRadioGroupDisabled
            )
          );
        }
        else if ((parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUTORIZADA
          || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA
          || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_COSEGURO
          || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA)
          && (afiliadoSeleccionado !== null || (idPrestador !== null && idPrestador !== '')
           || (idSolicitud !== '' && idSolicitud !== null) ||
          idBandeja === AUTORIZACIONES_BANDEJAS.OTRAS)) {
          dispatch(
            getSolicitudesContadoresGestion(
              afiliadoSeleccionado?.id_afiliado,
              efectorSeleccionado?.idEfectorFacturacion,
              idBandeja,
              idSolicitud,
              idSeccional,
              idPrestador,
              idCartillaPrestador,
              idEfectorFacturacion,
              fechaInicio,
              fechaFin,
              estadoSolicitudes ? parseInt(estadoSolicitudes) : null,
              idTipoSolicitud,
              true,
              pageSize === undefined ? undefined : page, /* Evitar que entre en recursive el ep*/
              pageSize,
              buscarContadores,
              setRadioGroupDisabled
            )
          );
        }
        else {
          dispatch(startAlerta("Debe seleccionar un Afiliado, Efector, Nro de Orden o Bandeja Otras antes de buscar una solicitud Autorizada|Rechazada|Terminada|Pendiente Coseguro.", "error"))
        }

      }
    }
  }

  const handleChangePage = (event, newPage) => {
    buscarConParametros(newPage + 1, solicitudesResult?.pageSize, false);
    window.scrollTo(0, 0)
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    buscarConParametros(solicitudesResult?.currentPage, parseInt(event.target.value, 10), false);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExportExcel = () => {
    dispatch(
      generateExcelConsultaAuditoria(
        afiliadoSeleccionado?.id_afiliado,
        efectorSeleccionado?.idEfectorFacturacion,
        idBandeja,
        idSolicitud,
        idSeccional,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacion,
        fechaInicio,
        fechaFin,
        estadoSolicitudes ? parseInt(estadoSolicitudes) : null,
        idTipoSolicitud
      )
    );
  };

  const componentRef = React.useRef();

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={3}>
            <AutorizacionesBuscador hideTitle={true} disabled={radioGroupDisabled} />
          </Grid>
          {/*<Grid item xs={12} md={3} >
            <AutoCompleteEfectorFacturacion
              todos
              dontExecuteFetch
              showNombreFantasia={true}
              disabled={radioGroupDisabled} />
          </Grid>*/}
          <Grid item xs={12} md={3} /*style={{ marginTop: -5 }}*/>
            <Paper className={classes.input} style={{ paddingTop: 10, paddingBottom: 10 }}>
              <AutoCompletePrestadorAut
                autoCompleteValue={
                  {
                    prestadorCuit: cuitPrestador,
                    prestadorNombreApellido: nombrePrestador,
                    efectorFacturacionRazonSocial: "",
                    efectorFacturacionCuit: "",
                  }
                }
                onChangeHandler={(value) => {
                  console.log(value);
                  if (value) {
                    setearVariosValores({
                      cuitPrestador: value.prestadorCuit,
                      nombrePrestador: value.prestadorNombreApellido,
                      idPrestador: value.idPrestador,
                      idCartillaPrestador: value.idCartillaPrestador,
                      idEfectorFacturacion: value.idEfectorFacturacion
                    });
                  } else {
                    setearVariosValores({
                      cuitPrestador: '',
                      nombrePrestador: '',
                      idPrestador: '',
                      idCartillaPrestador: '',
                      idEfectorFacturacion: '',
                    });
                  }
                }}
                disabled={radioGroupDisabled}
                gestionAuditoria={true}
              />
            </Paper>
          </Grid>
          {/* <Grid item xs={12} md={3}>
            <Grid
              container
              spacing={3}
              style={{ display: "flex", padding: 5 }}
            >
              <Grid item xs={12} md={12} >
                <BuscadorPractica
                  cod={codigoPractica}
                  label="Código Practica"
                  gestionAutorizacion={true}
                  setCod={(val) => setCodigoPractica(val)}
                />
              </Grid>
            </Grid>
          </Grid> */}
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <TextField
                margin="normal"
                // InputProps={{ classes: { input: classes.NroAfi } }}
                fullWidth
                type='number'
                label="N° Orden"
                name="idSolicitud"
                value={idSolicitud}
                autoComplete="off"
                disabled={radioGroupDisabled}
                onChange={(e) => {
                  if (e.target.value === '' || e.target.value > 0) setIdSolicitud(e.target.value)
                }}
                onKeyUp={(e) => { if (e.key === 'Enter') buscarConParametros() }}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Buscar"
                        onClick={buscarConParametros}
                        disabled={radioGroupDisabled}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Inicio"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={radioGroupDisabled}
                  value={
                    moment(fechaInicio).isValid() ? moment(fechaInicio) : null
                  }
                  onChange={(date) => {
                    setearValor("fechaInicio", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Fin"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={radioGroupDisabled}
                  value={moment(fechaFin).isValid() ? moment(fechaFin) : null}
                  onChange={(date) => {
                    setearValor("fechaFin", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={2} style={{ marginLeft: '5px', marginBottom: '10px', marginTop: -5 }}>
        <Paper className={classes.input} style={{ paddingTop: 10, paddingBottom: 10 }}>
          <FormControl fullWidth>
            <InputLabel>Tipo Solicitud</InputLabel>
            <Select
              fullWidth
              id="idTipoSolicitud"
              value={idTipoSolicitud}
              label="Tipo Solicitud"
              disabled={radioGroupDisabled}
              onChange={(e) => setIdTipoSolicitud(e.target.value)}
            >
              <MenuItem
                key={0}
                value={0}
              >
                Todos
              </MenuItem>
              {tiposSolicitudes?.length > 0 &&
                tiposSolicitudes
                .filter((tipoSolicitud) => tipoSolicitud.idTipo !== TIPOS_AUTORIZACIONES.PRESUPUESTOS)
                .map((tipoSolicitud) => (
                  <MenuItem
                    key={tipoSolicitud.idTipo}
                    value={tipoSolicitud.idTipo}
                  >
                    {tipoSolicitud.descripcionTipo}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Paper>
      </Grid>
      <Grid item xs={12} md={2} style={{ marginLeft: '5px', marginBottom: '10px', marginTop: -5 }}>
        <Paper className={classes.input} style={{ paddingTop: 10, paddingBottom: 10 }}>
          <FormControl fullWidth>
            <InputLabel>Bandeja</InputLabel>
            <Select
              fullWidth
              id="idBandeja"
              value={idBandeja}
              label="Bandeja"
              disabled={radioGroupDisabled}
              onChange={(e) => setIdBandeja(e.target.value)}
            >
              <MenuItem
                key={0}
                value={0}
              >
                Todas
              </MenuItem>
              {bandejasDeUsuario?.length > 0 &&
                bandejasDeUsuario.filter(s => s.idBandeja !== AUTORIZACIONES_BANDEJAS.PRACTICAS_INTERNACION).map((bandeja) => (
                  <MenuItem
                    key={bandeja.idBandeja}
                    value={bandeja.idBandeja}
                  >
                    {bandeja.descripcion}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Paper>
      </Grid>
      <Grid item xs={12} md={2} style={{ marginLeft: '5px', marginBottom: '10px', marginTop: -5 }}>
        <Paper className={classes.input} style={{ paddingTop: 10, paddingBottom: 10 }}>
          <FormControl fullWidth>
            <InputLabel>Seccional</InputLabel>
            <Select
              fullWidth
              id="idSeccional"
              value={idSeccional}
              label="Seccional"
              disabled={radioGroupDisabled}
              onChange={(e) => setIdSeccional(e.target.value)}
            >
              <MenuItem
                key={0}
                value={0}
              >
                Todas
              </MenuItem>
              {itemsSeccionales?.length > 0 &&
                itemsSeccionales.map((seccional) => (
                  <MenuItem
                    key={seccional.id_seccional}
                    value={seccional.id_seccional}
                  >
                    {seccional.descripcion_seccional.substr(0, 18)}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper
          style={{ paddingLeft: 0, textAlign: 'center' }}
          component={"div"}
          elevation={1}
        >
          <Typography
            style={{
              color: "#000000",
              fontSize: "1rem",
              fontWeight: 'bold'
            }}
            variant={"subtitle1"}
            component={"p"}
          >
            Estados
          </Typography>
        </Paper>
        <Paper style={{ padding: "0.25rem", marginTop: -5, alignItems: "center" }}>
          <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={estadoSolicitudes}
            onChange={(e) => {
              dispatch(setEstadoSolicitudes(e.target.value));
            }}
          >
            {arrayEstadosSolicitudes.map((estadoSolicitud) => {
              const contador = solicitudesContadores?.find(s => s.idEstado === estadoSolicitud[1]);
              const label =
                estadoSolicitud[0].charAt(0) +
                estadoSolicitud[0].replace(/_/g, " ").toLowerCase().slice(1) +
                ((contador && contador !== undefined)
                  ?
                  `(${contador.total === null ? "..." : contador.total})`
                  :
                  `(...)`
                );
              return (
                <FormControlLabel
                  key={estadoSolicitud[1]?.toString()}
                  style={{ marginLeft: "0.5rem" }}
                  label={label}
                  value={estadoSolicitud[1]?.toString()}
                  control={<Radio />}
                  disabled={radioGroupDisabled}
                />
              );
            })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHeadGestionAuditoria
              classes={classes}
              {...{ order, orderBy }}
              //onRequestSort={handleRequestSort}
              estadoSolicitudes={estadoSolicitudes}
            />
            <TableBody>
              {solicitudesResult?.results?.length > 0 ? (
                // items
                solicitudesResult?.results?.map((item) => (
                  <SolicitudItem
                    item={item}
                    setRedirect={setRedirect}
                    permisosUser={permisosUser}
                    key={item.idSolicitud?.toString()}
                    estadoSolicitudes={estadoSolicitudes}
                    bandejasAutorizacion={bandejasAutorizacion}
                    tieneAreaCentroMedico={tieneAreaCentroMedico}
                    tieneAreaAutorizaciones={tieneAreaAutorizaciones}
                    permisoIngresoInterDom={props.permisoIngresoInterDom}
                    permisoIngresoAutorizaciones={props.permisoIngresoAutorizaciones}
                    expandirPracticas={tieneAreaAutorizacionesNacional &&
                      (parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE
                        || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION
                        || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES
                        || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA
                        || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA
                        || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS
                        || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO
                      )
                    }
                    filtros={
                      {
                        idAfiliado: afiliadoSeleccionado?.id_afiliado,
                        idEfectorFacturacion: efectorSeleccionado?.idEfectorFacturacion,
                        idBandeja,
                        idSolicitud,
                        idSeccional,
                        idPrestador,
                        idCartillaPrestador,
                        idEfectorFacturacionPrestador: idEfectorFacturacion,
                        fechaDesde: fechaInicio,
                        fechaHasta: fechaFin,
                        idEstadoSolicitud: estadoSolicitudes ? parseInt(estadoSolicitudes) : null,
                        idTipoSolicitud,
                        spinner: true,
                        pageSize: solicitudesResult?.pageSize,
                        page: solicitudesResult?.currentPage,
                        buscarContadores: true,
                        setRadioGroupDisabled: setRadioGroupDisabled
                      }
                    }
                    {...props}
                  />
                ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {solicitudesResult?.results?.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={tieneAreaAutorizacionesNacional ? [5, 10, 15, 20] : [10, 15, 20, 25, 50]}
            component="div"
            count={solicitudesResult?.rowCount || 0}
            rowsPerPage={solicitudesResult?.pageSize || 0}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {(parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS 
      || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO) &&
        solicitudesResult?.results?.length > 0 &&
        <Grid item xs={12} style={{ marginTop: -50 }}>
          <Grid item container justifyContent='center'>
            <Grid item xs={6}>
              <ToolbarXLSPDF
                paper={true}
                handleExportExcel={() => handleExportExcel()}
                iconVerde={true}
              />
            </Grid>
          </Grid>
        </Grid>}
      {redirect && (
        <Redirect
          to={{
            pathname: '/autorizaciones',
            state: {
              from: '/autorizaciones/gestion'
            },
          }}
        />
      )}
    </Grid>
  );
};
